import hljs from 'highlight.js';
import { html as beautifyHtml, js as beautifyJson } from 'js-beautify';
import 'assets/css/icons/iconStyles.css';
import 'highlight.js/styles/atom-one-dark.css';
import ToastAlert, { ToastAlertIconType } from 'components/Common/ToastAlert/ToastAlert';
import { safeJSONParse, sfLog } from 'helpers/sf_utils';

export const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
        ToastAlert.fire({ icon: ToastAlertIconType.OK, title: 'Text copied to clipboard.' })
    }).catch(err => {
        sfLog('Failed to copy text: ', err);
    });
};

export const getTextFromHtml = (html) => {
    const tempDivElement = document.createElement('div');
    tempDivElement.innerHTML = html;
    return tempDivElement.textContent || tempDivElement.innerText || "";
};

export const beautifyAndHighlightValue = (val) => {
    let highlighted;
    if (typeof val === 'string') {
        if (val.trim().startsWith('{') || val.trim().startsWith('[')) {
            const parsedVal = safeJSONParse(val, val);
            if (parsedVal == val) {
                highlighted = val;
            } else {
                // Format the source so duplicate keys and numeric values stay intact in logs.
                highlighted = hljs.highlight('json', beautifyJson(val, { indent_size: 4 })).value;
            }
        } else {
            highlighted = hljs.highlight('xml', beautifyHtml(val, { indent_size: 4 })).value;
        }
    } else {
        highlighted = val;
    }
    return highlighted;
};